module.exports = ":host ::ng-deep .bottomRight {\n  max-height: 30px; }\n"